import { useEffect } from 'react';
import { Button } from '../ui/index.js';
import { isStaleChunkError, reloadForNewVersion } from './stale-version.js';

/**
 * Page d'erreur par défaut du routeur (remplace le message anglais de TanStack Router). Une version
 * périmée de l'application (fichiers disparus après un déploiement) déclenche un rechargement unique.
 */
export function AppErrorPage({ error }: { error: unknown }) {
  const stale = isStaleChunkError(error);
  useEffect(() => {
    if (stale) reloadForNewVersion();
  }, [stale]);
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-xl font-semibold text-ink">
        {stale ? 'Une nouvelle version est disponible' : 'Un problème est survenu'}
      </h1>
      <p className="text-ink-2">
        {stale
          ? 'L’application a été mise à jour pendant que cette page était ouverte. Rechargez pour continuer.'
          : 'Cette page n’a pas pu s’afficher. Rechargez ; si le problème persiste, réessayez dans quelques minutes.'}
      </p>
      <Button onClick={() => window.location.reload()}>Recharger</Button>
    </main>
  );
}
